export const green50 = "#e8f7eb";
export const green100 = "#d6f4e1";
export const green200 = "#adeac3";
export const green300 = "#84dfa6";
export const green400 = "#5bd588";
export const green500 = "#33cb6b";
export const green600 = "#28c056";
export const green700 = "#1eb741";
export const green800 = "#14ac2c";
export const green900 = "#0aa217";
export const green1000 = "#028009";
export const greenA100 = "#5bf4c0";
export const greenA200 = "#4ce5a0";
export const greenA400 = "#19b135";
export const greenA500 = "#048708";
export const greenA1000 = "#114625";
